import { render, staticRenderFns } from "./UpcomingSessions.vue?vue&type=template&id=ac6e2440&scoped=true&"
import script from "./UpcomingSessions.vue?vue&type=script&lang=ts&"
export * from "./UpcomingSessions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6e2440",
  null
  
)

export default component.exports